import { render } from "./EditVerticalBarChart.vue?vue&type=template&id=21001669"
import script from "./EditVerticalBarChart.vue?vue&type=script&lang=js"
export * from "./EditVerticalBarChart.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__